export default __webpack_public_path__ + "static/media/img-7.b4ec1d21.jpg";